import React from 'react'
import { Col, Row } from 'react-bootstrap'

// Hooks
import { useState } from '../../../../hooks'

// Components
import ReportFormFilter from '../../Form/Filter'
import ReportTableUnSampled from '../../Table/UnSampled'

const ReportContainerUnSampled = () => {
  const [filter, setFilterState] = useState()

  const handleFilterChange = (filter) => {
    setFilterState(filter)
  }

  return (
    <Row>
      <Col className="mb-3">
        {filter ? (
          <ReportTableUnSampled
            filter={filter}
            onFilterChange={handleFilterChange}
          />
        ) : (
          <ReportFormFilter
            onFilterChange={handleFilterChange}
            name="unsampled"
          />
        )}
      </Col>
    </Row>
  )
}

export default ReportContainerUnSampled
